import {LEFT_BASE_URL} from 'util/UrlConstant';
import {SyncPost,SyncGet} from 'jscommon/ajaxUtil.js'

(function (authUtil) {
  jQuery.extend({

    YHTAuthMenu: [
      {
        id: 'homePage',
        link: `${LEFT_BASE_URL}/usercenter/home`,
        icon: 'cl-House',
        title: 'homePage',
        color: '#FFCA28',
        children:[]
      },
      {
        id: 'configMgt',
        link: `${LEFT_BASE_URL}/usercenter/user`,
        icon: 'cl-tool',
        title: 'basicSetting',
        color: '#FFCA28',
        children: [{
          id: 'BasicInfo',
          link: `${LEFT_BASE_URL}/usercenter/user`,
          title: 'basicinfo',
          color: '#1E88E5'
        }, {
          id: 'Accountmgt',
          link: `${LEFT_BASE_URL}/usercenter/usermng`,
          sublink: [`${LEFT_BASE_URL}/usercenter/emailMOD`,
          `${LEFT_BASE_URL}/usercenter/mobileMOD`],
          title: 'accmgt',
          color: '#1E88E5'
        }, {
          id: 'AccountMerge',
          link: `${LEFT_BASE_URL}/usercenter/merge`,
          title: 'accmerge',
          color: '#1E88E5'
        }, {
          id: 'SecurityScore',
          link: `${LEFT_BASE_URL}/usercenter/securityscore`,
          title: 'securitySetting',
          color: '#1E88E5'
        }, {
          id: 'securityMgt',
          link: `${LEFT_BASE_URL}/usercenter/security`,
          title: 'changepwd',
          color: '#1E88E5'
        }, {
          id: 'UserAuth',
          link: `${LEFT_BASE_URL}/usercenter/userauth`,
          title: 'userauth',
          color: '#1E88E5'
        }, {
            id: 'AccountLogout',
            link: `${LEFT_BASE_URL}/usercenter/logout`,
            title: 'accLogout',
            color: '#1E88E5'
        }]
      },
        {
        id: 'enterpriseMgt',
        link: `${LEFT_BASE_URL}/usercenter/enterprise`,
        icon: 'cl-enterprise',
        title: 'enterprise',
        color: '#1E88E5',
        children:[]
      },
        {
        id: 'appMgt',
        link: `${LEFT_BASE_URL}/usercenter/myapp`,
        icon: 'cl-shield',
        title: 'myapp',
        color: '#1E88E5',
        children:[]
      },
        {
        id: 'loginhistory',
        link: `${LEFT_BASE_URL}/usercenter/loginhistory`,
        icon: 'cl-log-history',
        title: 'loginhistory',
        color: '#1E88E5',
        children:[]
      }],

    YHTFilterdAuthMenu: null,
    /*权限表*/
    YHTAuthList: {
      'homePage': [0, 7],
      'configMgt': [0, 7],
      'enterpriseMgt': [0, 7],
      'appMgt': [0, 7],
      'loginhistory': [0, 7],
      'entMgt': [0, 7],
      'entMgtsub1': [0, 7]
    },
    isExclusiveCloudAllowd: ['homePage','configMgt', 'BasicInfo', 'Accountmgt', 'securityMgt','SecurityScore','AccountLogout','loginhistory'],
    YHTAuthMap: {
      'systemmanager': "系统管理员", //0
      'user': '用户' //7
    },



    AuthBasepath: '/',
    getYHTFilterdAuthMenu: function (index) {
      var _YHTFilterdAuthMenu = authUtil.YHTFilterdAuthMenu;

      if (!_YHTFilterdAuthMenu) {
          var _YHTFilterdAuthMenu = [];
          var iSYHTLiteVersion = authUtil.iSYHTLiteVersion();
          var authID = 7;

          $.each(authUtil.YHTAuthMenu, function (key, val) {
            if (iSYHTLiteVersion) {
              if ($.inArray(val.id, authUtil.isExclusiveCloudAllowd) !== -1) {
                var _menuItem = JSON.parse(JSON.stringify(val));
                _menuItem.children = [];
                if (val.children && val.children.length) {
                  var _submenulist = val.children.concat([]);

                  $.each(_submenulist, function (key2, val2) {
                    if ($.inArray(val2.id, authUtil.isExclusiveCloudAllowd) !== -1) {
                      _menuItem.children.push(val2);
                    }
                  });
                }
                (window.isAllow&&window.isAllow.allowUserPwd)? null : _menuItem.children.splice(3,1)
                _YHTFilterdAuthMenu.push(_menuItem);
              }
            } else {
              let menuItemAuth = authUtil.YHTAuthList[val.id];
              if (menuItemAuth && menuItemAuth.length && ($.inArray(authID, menuItemAuth) > -1)) {
                // if (isNC65USER && val.id == "configMgt") {
                //   _YHTFilterdAuthMenu.push();
                // } else {
                  _YHTFilterdAuthMenu.push(val);
                // }

              }
            }
          });
        // }
        authUtil.YHTFilterdAuthMenu = _YHTFilterdAuthMenu;
      }
      // if (index !== undefined && index - 0 < _YHTFilterdAuthMenu.length) {
      //   return _YHTFilterdAuthMenu[index];
      // } else {
      return _YHTFilterdAuthMenu;
      // }

    },
    getNC65configMgt: function () {
      const NC65Menu = JSON.parse(JSON.stringify(authUtil.YHTAuthMenu));
      var retMenu = [];

      $.each(NC65Menu, (index,item) => {
        // if (item.id === 'configMgt') {
        //   retMenu.push(item);
        // }
          retMenu.push(item);
      });
      return retMenu;
    },
    iSYHTLiteVersion: function () {
        // Todo 后台专属云系统配置统一获取，接口统一，注册找回密码、激活、申诉等页面改为redux统一管理
        let ret = false;
        if (window.isExclusiveCloudChecked) { return window.ISYHTLiteVersion; }
        SyncPost('/user/isExclusiveCloud', null, false,
            function (result) {
                ret = result.flag;
                let sgdata=result.data
                window.isExclusiveCloudChecked = true;
                window.ISSgDataCenter = sgdata.isSgDataCenter
            },
            function (xhr, status, err) {
                return true;
            });
        window.ISYHTLiteVersion = ret;
        return ret;
    },

    isNC65User: function (userName, userId) {
      let ret = true;

      // if (authUtil.iSYHTLiteVersion()) { return false; }

      $.ajax({
        url:  `${window.yhtUserCenterBaseUrl}/ncUser/isNC65?ts=${new Date().getTime()}`,
        dataType: 'json',
        type: 'GET',
        data: { 'userName': userName, 'userId': userId },
        async: false,
        success: function (result) {
          if (result.status) {
            ret = result.isNC65;
          } else {
            ret = false;
          }
          window.CheckNC65YHTUser = ret;
        }.bind(this),
        error: function (xhr, status, err) {
          ret = false;

        }.bind(this)
      });
      return ret
    },

    checkNCUserPubKey: function (userId, plainPassword) {
      // if (authUtil.isNC65User("", userId)) {
        var pubkey;
        SyncGet('/user/pubkey', false, function (robj) {
          var exponent = robj.exponent;
          var modulus = robj.modulus;
          //tokeninfo
          pubkey = window.RSAUtils.getKeyPair(exponent, '', modulus);
        }, function (xhr, status, err) {
          if (window.console) {
            console.error('/user/pubkey', status, err.toString());
          }
        });
        var tokeninfo = (window.RSAUtils.encryptedString(pubkey, plainPassword) + "_encrypted");
        return tokeninfo;
      // } else {
      //   return null;
      // }
    },

    /** nc65 用户修改密码需要加密参数 */
    getTpwd: function (exponent, modulus, plainPassword) {

      if (exponent && modulus && plainPassword) {
        var pubkey = window.RSAUtils.getKeyPair(exponent, '', modulus);
        var tokeninfo = (window.RSAUtils.encryptedString(pubkey, plainPassword) + "_encrypted");
        return tokeninfo;
      }
    },


    /*当前用户权限*/
    YHTAuthID: function () {
      var authid = -1;
      SyncPost('/manager/queryRole.do', false, function (result) {
        var dataObj = result.extinfo;
        if (dataObj && dataObj.roleName) {
          authid = dataObj.roleID;
        }
      }, function (xhr, status, err) {
        window.console && console.error('authisAdmin error:', status, err.toString());
      });
      return authid;
    },

    /*当前用户权限*/
    YHTAuthName: function () {
      var authname = 'user';
      SyncPost('/manager/queryRole.do', false, function (result) {
        var dataObj = result.extinfo;
        if (dataObj && dataObj.roleName) {
          authname = dataObj.roleName;
        }
      }, function (xhr, status, err) {
        window.console && console.error('authisAdmin error:', status, err.toString());
      });
      return authUtil.YHTAuthMap[authname] || authUtil.YHTAuthMap['user'];
    },

    /*是否有权限*/
    YHTAuthIsAdmin: function (path) {
      if (window.CheckNC65YHTUser) {
        if (path == "/usercenter/mobileMOD" || path == "/usercenter/mobileMOD") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
      // var authid = authUtil.YHTAuthID();
      // if (!path) return false;
      // var patharr = path.split('/');
      // var _path = patharr[patharr.length - 1];
      // var authlist = authUtil.YHTAuthList[_path];
      // if (authlist) {
      //   if ($.inArray(authid, authlist) > -1) {
      //     return true;
      //   } else {
      //     //alert("对不起！你没有该访问权限.");
      //     return false;
      //   }
      // } else {
      //   /*未配置在YHTAuthList 则表示无权限限制*/
      //   return false;
      // }
    },

    YHTAuthIsAdminByID: function (path, authID) {
      var authid = authID;
      if (!path) return false;
      var patharr = path.split('/');
      var _path = patharr[patharr.length - 1];
      var authlist = authUtil.YHTAuthList[_path];
      if (authlist) {
        if ($.inArray(authid, authlist) > -1) {
          return true;
        } else {
          //alert("对不起！你没有该访问权限.");
          return false;
        }
      } else {
        /*未配置在YHTAuthList 则表示无权限限制*/
        return false;
      }
    }

  })
})($);
module.exports = $;